export default __webpack_public_path__ + "static/media/mob-cover2.7393eefe.jpg";